import { Button } from '@/components/ui/button'
import type { WorkspaceSettings } from './types'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading01Icon } from '@hugeicons/core-free-icons'
import {
  SettingsWell,
  SettingsCard,
  SettingsRow,
  SettingsToggle,
  SettingsFooter,
  settingsSaveClass,
} from '@/components/shared/settings/SettingsKit'

interface HashFragSettingsTabProps {
  settings: WorkspaceSettings
  onSettingsChange: (settings: Partial<WorkspaceSettings>) => void
  onSave: () => void
  isSaving?: boolean
  isDirty?: boolean
}

export default function HashFragSettingsTab({
  settings,
  onSettingsChange,
  onSave,
  isSaving = false,
  isDirty = false,
}: HashFragSettingsTabProps) {
  return (
    <SettingsWell>
      <SettingsCard>
        <SettingsRow
          title="URL fragments (#)"
          description="Workspace default for counting #pricing and #faq as separate pages. Each site can override it in Site settings."
        >
          <SettingsToggle
            title="Track URL fragments"
            description="Useful for single-page apps and in-page sections"
            checked={settings.hashFragTracking}
            onCheckedChange={(checked) => onSettingsChange({ hashFragTracking: checked })}
          />
          <SettingsToggle
            title="Single-page app mode"
            description="Count each hash change as a page view"
            checked={settings.spaMode}
            disabled={!settings.hashFragTracking}
            onCheckedChange={(checked) => onSettingsChange({ spaMode: checked })}
          />
        </SettingsRow>
        <SettingsRow
          title="Clean URLs"
          description="Only applies while fragment tracking is off."
        >
          <SettingsToggle
            title="Strip the fragment from URLs"
            description="/pricing#plans is reported as /pricing"
            checked={settings.stripHash}
            disabled={settings.hashFragTracking}
            onCheckedChange={(checked) => onSettingsChange({ stripHash: checked })}
          />
        </SettingsRow>
        <SettingsFooter>
          <Button onClick={onSave} disabled={isSaving || !isDirty} className={`${settingsSaveClass} gap-1.5`}>
            {isSaving && <HugeiconsIcon icon={Loading01Icon} size={14} className="animate-spin" />}
            {isSaving ? 'Saving…' : 'Save changes'}
          </Button>
        </SettingsFooter>
      </SettingsCard>
    </SettingsWell>
  )
}
